import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = {
  key: 0,
  class: "menu-content pt-1 pb-1",
  style: {"background-color":"#2948a0"}
}
const _hoisted_5 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_6 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_7 = {
  key: 0,
  class: "menu-content pt-1 pb-1",
  style: {"background-color":"#2948a0"}
}
const _hoisted_8 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_9 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_10 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_11 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = { class: "menu-link" }
const _hoisted_14 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_15 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_16 = { class: "menu-title" }
const _hoisted_17 = {
  key: 0,
  class: "btn btn-icon btn-active-light-primary position-relative w-10px h-10px w-md-20px h-md-2px",
  id: "kt_drawer_chat_toggle"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" }, null, -1)
const _hoisted_19 = {
  class: "h-4px w-4px position-absolute translate-middle start-100 animation-blink",
  style: {"color":"#50ce89","top":"-8px !important"}
}
const _hoisted_20 = {
  key: 1,
  class: "btn btn-icon btn-active-light-primary position-relative w-10px h-10px w-md-20px h-md-2px",
  id: "kt_drawer_chat_toggle"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" }, null, -1)
const _hoisted_22 = {
  class: "h-4px w-4px position-absolute translate-middle start-100 animation-blink",
  style: {"color":"#50ce89","top":"-8px !important"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = { class: "menu-link" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_29 = { class: "menu-title" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_33 = { class: "menu-title" }
const _hoisted_34 = { class: "menu-link" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_36 = { class: "menu-title" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-white" })
], -1)
const _hoisted_40 = { class: "menu-title" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (item.route == '/manage')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(item.heading)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (item.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (item.route != '/manage' && _ctx.isVisible(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate(item.heading)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (menuItem.heading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (
                _ctx.checkAbility(menuItem.ability.method, menuItem.ability.resource)
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_router_link, {
                            onClick: _ctx.InlineButtonClickHandler,
                            class: "menu-link",
                            "active-class": "active",
                            to: menuItem.route
                          }, {
                            default: _withCtx(() => [
                              (menuItem.svgIcon || menuItem.fontIcon)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    (_ctx.asideMenuIcons === 'font')
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 0,
                                          class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                        }, null, 2))
                                      : (_ctx.asideMenuIcons === 'svg')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                            _createVNode(_component_inline_svg, {
                                              src: menuItem.svgIcon
                                            }, null, 8, ["src"])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "to"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (menuItem.sectionTitle && _ctx.isVisible(menuItem))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"]),
                    "data-kt-menu-sub": "accordion",
                    "data-kt-menu-trigger": "click"
                  }, [
                    _createElementVNode("span", _hoisted_13, [
                      (menuItem.svgIcon || menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            (_ctx.asideMenuIcons === 'font')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                }, null, 2))
                              : (_ctx.asideMenuIcons === 'svg')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    _createVNode(_component_inline_svg, {
                                      src: menuItem.svgIcon
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.translate(menuItem.sectionTitle)) + " ", 1),
                        (
                    menuItem.route == '/appraisals' &&
                    _ctx.appraisalsRequestsCount > 0
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.appraisalsRequestsCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (menuItem.route == '/ads' && _ctx.adsCount > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _hoisted_21,
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.adsCount), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_23
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub || menuItem.pages, (item2, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (item2.heading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (
                      _ctx.checkAbility(item2.ability.method, item2.ability.resource)
                    )
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      onClick: _ctx.InlineButtonClickHandler,
                                      class: "menu-link",
                                      "active-class": "active",
                                      to: item2.route
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_25,
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (item2.sectionTitle && _ctx.isVisible(item2))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                "data-kt-menu-sub": "accordion",
                                "data-kt-menu-trigger": "click"
                              }, [
                                _createElementVNode("span", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                  _hoisted_30
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                      (item3.heading && _ctx.isVisible(item3))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_component_router_link, {
                                              onClick: _ctx.InlineButtonClickHandler,
                                              class: "menu-link",
                                              "active-class": "active",
                                              to: item3.route
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_32,
                                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick", "to"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item3.sectionTitle && _ctx.isVisible(item3))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass([{ show: _ctx.hasActiveChildren(item3.route) }, "menu-item menu-accordion"]),
                                            "data-kt-menu-sub": "accordion",
                                            "data-kt-menu-trigger": "click"
                                          }, [
                                            _createElementVNode("span", _hoisted_34, [
                                              _hoisted_35,
                                              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.translate(item3.sectionTitle)), 1),
                                              _hoisted_37
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass([{ show: _ctx.hasActiveChildren(item3.route) }, "menu-sub menu-sub-accordion"])
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item3.sub, (item6, k) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                                  (item6.heading && _ctx.isVisible(item6))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                        _createVNode(_component_router_link, {
                                                          onClick: _ctx.InlineButtonClickHandler,
                                                          class: "menu-link",
                                                          "active-class": "active",
                                                          to: item6.route
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_39,
                                                            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate(item6.heading)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick", "to"])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128))
                                            ], 2)
                                          ], 2))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ], 2)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128)),
      _hoisted_41
    ])
  ], 512))
}